import { ISearchPage, IPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";

export interface IFiltrationDetails {
    id: string,
    agent: string,          // "国信招标集团股份有限公司湖北分公司"
    agentAddress: string,          // "武汉市洪山区徐东大街97号龙潭SOMO A座16楼"
    agentContacts: string,          // ""
    agentEmail: string,          // null
    bidCode: string,          // null
    bidEndTime: string,          // "2021-06-21 09:string,          //30"
    bidMethod: string,          // "公开招标"
    bidStartTime: string,          // "2021-05-25 15:string,          //44"
    category: string,          // "商业服务"
    closeTime: string,          // ""
    code: string,          // "GXTC-C-2113199"
    createTime: string,          // "2021-05-26 09:string,          //05:string,          //00"
    createUser: string,          // "root"
    currency: string,          // null
    deleteFlag: string,          // 0
    detailLink: string,          // "http:string, 
    fileDownloadEndTime: string,          // "2021-06-18 17:string,          //30"
    fileDownloadStartTime: string,          // "2021-05-25 15:string,          //44"
    fileSaleEndTime: string,          // "2021-06-04 17:string,          //30"
    fileSaleStartTime: string,          // "2021-05-25 15:string,          //44"
    filterStatus: string,          // "initial"
    gatherStatus: string,          // "detail"
    keywords: string,          // null
    name: string,          // "公开招标"
    noticeType: string,          // null
    openingTime: string,          // "2021-06-21 09:string,          //30"
    orderNum: string,          // null
    overview: string,          // null
    payment: string,          // null
    pdfviewLink: string,          // "http:string,  
    planCode: string,          // null
    price: string,          // null
    pubTime: string,          // "2021/05/25"
    purchaser: string,          // "湖北省外文书店有限公司"
    purchaserAddress: string,          // "湖北省武汉市武昌区中南路11号"
    purchaserContacts: string,          // ""
    purchaserEmail: string,          // null
    rawContent: string,          // null
    readNum: string,          // null
    region: string,          // "湖北省"
    sellingPrice: string,          // null
    signEndTime: string,          // "2021-06-04 17:string,          //30"
    signStartTime: string,          // "2021-05-25 15:string,          //44"
    sourceFrom: string,          // "中国采购与招标网"
    spiderName: string,          // "chinabidding_spider"
    textContent: string,          // null
    title: string,          // "【湖北省外文书店有限公司后街房产招租】招标公告"
    updateTime: string,          // "2021-05-26 09:string,          //05:string,          //00"
    updateUser: string,          // "root"
    validity: string,          // null
    oid: string,
}

export interface IFiltrationSeachFields {
    "region"?: string,    // "地区",
    "source"?: string,    // "来源",
    "date"?: string,    // "截止日期",
    "startTime"?: string,    // "截止开始时间",
    "endTime"?: string,    // "截止结束时间",
    [key: string]: any
}

export interface IFiltrationSearch extends
    IFiltrationSeachFields, ISearchPage {

}

class FiltrationService {
    //列表
    async page(searchVo: IFiltrationSearch) {
        const apiUrl = "/initial/page";
        return await httpRequest.post<IPage<IFiltrationDetails>>(apiUrl, searchVo);
    }
    //批量删除
    async removeAll(searchVo: string[]) {
        const appPageUrl = "/initial/cancels";
        return await httpRequest.post(appPageUrl, searchVo);
    }
    //转移公告到识别库
    async shift(id: string) {
        const apiUrl = `/initial/transfer/${id}`;
        return await httpRequest.get<IFiltrationDetails>(apiUrl);
    }
}
export const filtrationService = new FiltrationService();